module.exports = __webpack_public_path__ + "img/ad-wizard-icon.bb80ae06.svg";